import React, { useEffect, useState } from "react";
import {
  Menu,
  MenuItem,
  Button,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const languages = [
  {
    code: "en",
    name: "English",
    flag: "🇺🇸",
    flagImg:
      "https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.5.0/flags/4x3/gb.svg",
  },
  {
    code: "fr",
    name: "Français",
    flag: "🇫🇷",
    flagImg:
      "https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.5.0/flags/4x3/fr.svg",
  },

];

const LanguageSelector = ({ changeLanguage, renderTrigger }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const localLang = localStorage.getItem("preferredLang");
  const [selectedLanguage, setSelectedLanguage] = useState(languages[0]);

  useEffect(() => {
    const storedLang = languages.find((lang) => lang.code === localLang);
    if (storedLang) setSelectedLanguage(storedLang);
  }, []);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleLanguageSelect = (lang) => {
    setSelectedLanguage(lang);
    localStorage.setItem("preferredLang", lang.code);
    changeLanguage(lang.code);
    handleClose();
  };

  return (
    <>
      {/* 👇 CUSTOM TRIGGER */}
      <div onClick={handleClick} style={{ cursor: "pointer" }}>
        {renderTrigger(selectedLanguage)}
      </div>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        disablePortal
        disableScrollLock
      >
        {languages.map((lang) => (
          <MenuItem key={lang.code} onClick={() => handleLanguageSelect(lang)}>
            <ListItemIcon>
              <img
                src={lang.flagImg}
                alt={lang.name}
                style={{ width: 20, height: 15 }}
              />
            </ListItemIcon>
            <ListItemText primary={lang.name} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};



export default LanguageSelector;
